module.exports = __webpack_public_path__ + "static/media/iconCanvas07.00a77243.svg";